var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.isAuthenticated)?_c('div',[_c('NonLoggedHeader')],1):_c('div',[_c('LoggedHeader',{on:{"mobile-menu-toggle":_vm.handleMobileMenuToggle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }